module.exports = __webpack_public_path__ + "img/icon-save.292bf5f2.svg";